import { Button, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { DropDownIconNew } from '../../../assets/customIcons';
import { MuiBorderBottom, MuiStack } from '../../../components';
import { SignatureIndex } from '../../../components/atoms/signature/Signature';
import DateTimePickerComponent from '../../../components/templates/dateTimePickerComponent';
import { InPerson } from '../../../constants';
import { red } from '../../../theme/palette';
import { systemColor } from '../../../theme/systemColor';
import NetPayableAmountSummaryDrawer from './netPayableAmountSummaryDrawer';
import useRbacController from '../../../builderPackage/rbac/useRbacController';
export default function ServiceEstimatePreCheckAndCustomerApproval(props) {
    var _rbacControl$SelectCu, _rbacControl$SelectCu2;
    var rbacControl = useRbacController('/jobCard');
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = useState(false), isOpenDrawer = _b[0], setIsOpenDrawer = _b[1];
    var labourCost = props.labourCost, partCost = props.partCost, estimateCost = props.estimateCost, approvalType = props.approvalType, markApprovalList = props.markApprovalList, onSelectedDate = props.onSelectedDate, selectedDate = props.selectedDate, selectedItem = props.selectedItem, inPersonImage = props.inPersonImage, setCanvasImage = props.setCanvasImage, isDisabled = props.isDisabled, timeError = props.timeError, isCostEstimationVisible = props.isCostEstimationVisible, isSignatureVisible = props.isSignatureVisible, allJobs = props.allJobs, enableShareOption = props.enableShareOption, setHasUnsavedChanges = props.setHasUnsavedChanges;
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleMenuItemClick = function (item) {
        // setSelectedItem(item);
        approvalType(item);
        handleClose();
    };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleSignatureChange = function () {
        setHasUnsavedChanges(true);
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, isCostEstimationVisible && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            backgroundColor: '#FFFFFF',
            border: '1px solid #DEE4EB',
            borderRadius: '12px 12px 0px 0px'
        },
        direction: 'column',
        padding: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, " ", t("Cost Estimated"), " ")), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            backgroundColor: '#F4F7FA',
            borderRadius: '8px'
        },
        direction: 'column',
        padding: 2,
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4"
    }, " ", t("PART_COST"), " "), /*#__PURE__*/ React.createElement(Typography, {
        id: "partCost",
        style: {
            fontWeight: '600',
            fontSize: '14px',
            whiteSpace: 'nowrap'
        }
    }, " \u20B9 ", partCost === null || partCost === void 0 ? void 0 : partCost.toFixed(2), " ")), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4"
    }, " ", t("LABOUR_COST"), " "), /*#__PURE__*/ React.createElement(Typography, {
        id: "labourCost",
        style: {
            fontWeight: '600',
            fontSize: '14px',
            whiteSpace: 'nowrap'
        }
    }, " \u20B9 ", labourCost === null || labourCost === void 0 ? void 0 : labourCost.toFixed(2), " ")), /*#__PURE__*/ React.createElement(MuiBorderBottom, null), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        style: {
            fontWeight: '600',
            fontSize: '14px'
        }
    }, t("Total Estimated Cost")), /*#__PURE__*/ React.createElement(Typography, {
        id: "totalEstimateCost",
        style: {
            fontWeight: '600',
            fontSize: '14px',
            whiteSpace: 'nowrap'
        }
    }, " \u20B9 ", estimateCost === null || estimateCost === void 0 ? void 0 : estimateCost.toFixed(2))), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(Button, {
        id: 'summary-btn',
        onClick: function () { return setIsOpenDrawer(true); }
    }, "View Summary"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        py: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            '&::after': {
                content: '"*"',
                color: 'red',
                marginLeft: '2px'
            },
            mb: 0.5,
            fontSize: 'lg',
            fontWeight: 'medium'
        }
    }, t("Estimated Delivery Time")), /*#__PURE__*/ React.createElement(DateTimePickerComponent, {
        onChange: onSelectedDate,
        selectedDate: selectedDate,
        isDisabled: isDisabled
    }), timeError && /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: red,
            paddingTop: '8px'
        }
    }, t("Please select future time")))), isSignatureVisible && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        style: {
            backgroundColor: '#FFFFFF',
            border: '1px solid #DEE4EB',
            borderRadius: '0px 0px 12px 12px'
        },
        padding: 2,
        sx: {
            alignItems: 'end'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 0.8
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            '&::after': {
                content: '"*"',
                color: 'red',
                marginLeft: '2px'
            }
        }
    }, t("MARK_APPROVEL")), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'start',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "selected-customer-approval",
        variant: "h2",
        sx: {
            color: systemColor.primary
        }
    }, !selectedItem ? "InPerson" : selectedItem.Name), !(rbacControl !== null && rbacControl !== void 0 && (_rbacControl$SelectCu = rbacControl.SelectCustomerApprovalType) !== null && _rbacControl$SelectCu !== void 0 && _rbacControl$SelectCu.hidden) && /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        onClick: handleClick,
        sx: {
            p: 0.5
        },
        disabled: rbacControl === null || rbacControl === void 0 || (_rbacControl$SelectCu2 = rbacControl.SelectCustomerApprovalType) === null || _rbacControl$SelectCu2 === void 0 ? void 0 : _rbacControl$SelectCu2.disabled
    }, /*#__PURE__*/ React.createElement(DropDownIconNew, {
        id: "customer-approval-dropdown-icon",
        sx: {
            stroke: systemColor.primary,
            width: '20px',
            height: '20px'
        }
    })), !isDisabled && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Menu, {
        disableScrollLock: true,
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: handleClose
    }, markApprovalList.map(function (item, index) {
        if (item.Name == 'Select')
            return null;
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "menu-item ".concat(index),
            key: index,
            onClick: function () { return handleMenuItemClick(item); }
        }, item.Name);
    }))))))), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.Name) === InPerson && isSignatureVisible && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        paddingLeft: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("SIGNATURE"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            border: '1px solid #DEE4EB',
            borderRadius: '12px'
        }
    }, /*#__PURE__*/ React.createElement(SignatureIndex, {
        setCanvasImage: setCanvasImage,
        canvasImage: inPersonImage,
        isDisabled: isDisabled,
        onSignatureChange: handleSignatureChange
    })))), /*#__PURE__*/ React.createElement(NetPayableAmountSummaryDrawer, {
        open: isOpenDrawer,
        onClose: function () {
            setIsOpenDrawer(false);
        },
        allJobs: allJobs
    }));
}
